import { render, staticRenderFns } from "./SocialContracts.vue?vue&type=template&id=5b06c5cb&scoped=true"
import script from "./SocialContracts.vue?vue&type=script&lang=js"
export * from "./SocialContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b06c5cb",
  null
  
)

export default component.exports